export const AUDITREPORTLIST_SEARCH = 'AUDITREPORTLIST_SEARCH';
export const AUDITREPORTLIST_PAGE = 'AUDITREPORTLIST_PAGE';
export const AUDITREPORTLIST_STARTDATE = 'AUDITREPORTLIST_STARTDATE';
export const AUDITREPORTLIST_ENDDATE = 'AUDITREPORTLIST_ENDDATE';
export const AUDITREPORTLIST_USER = 'AUDITREPORTLIST_USER'
export const AUDITREPORTLIST_ACTION ='AUDITREPORTLIST_ACTION'
export const AUDITREPORTLIST_STARTTIME = 'AUDITREPORTLIST_STARTTIME';
export const AUDITREPORTLIST_ENDTIME = 'AUDITREPORTLIST_ENDTIME';
export const AUDITREPORTLIST_CLIENT = 'AUDITREPORTLIST_CLIENT'
export const AUDITREPORTLIST_ATTENDANT = 'AUDITREPORTLIST_ATTENDANT'